module.exports = __webpack_public_path__ + "img/alphaIcon.c5aa8234.svg";